function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#9e9e9e",
  d: "M20.805 15.2v8.4H4.351V6.8h5.9a7.694 7.694 0 0 1 .564-2.4H4.351A2.383 2.383 0 0 0 2 6.8v16.8A2.383 2.383 0 0 0 4.351 26h16.454a2.383 2.383 0 0 0 2.351-2.4v-6zm-1.763 6H6.114l3.232-4.236 2.3 2.832 3.232-4.248zm3.291-10.932a5.434 5.434 0 0 0 .823-2.868 5.29 5.29 0 1 0-10.578 0 5.336 5.336 0 0 0 5.277 5.4 5.134 5.134 0 0 0 2.809-.84l3.667 3.74L26 14zm-4.466.132a3 3 0 1 1 2.938-3 2.971 2.971 0 0 1-2.938 3z",
  transform: "translate(-2 -2)"
});

function SvgIconContentsAnaly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContentsAnaly);
export default __webpack_public_path__ + "static/media/icon-contents-analy.e74b8ec4.svg";
export { ForwardRef as ReactComponent };